<template>
  <div>
    <div>
    <b-tabs>
        <b-tab v-for="file in files" :key="file.id" :title="file.originalName" lazy title-item-class="text-primary">
          <template #title>
            <b-icon icon="check-circle-fill" variant="success" v-if="file.accounted && !file.removeable" class="mr-1"></b-icon>
            <b-icon icon="check-circle-fill" variant="secondary" v-else-if="!file.accounted && !file.removeable" class="mr-1"></b-icon>
            <b-icon icon="file-earmark-text" variant="secondary" v-else-if="file.removeable" class="mr-1"></b-icon>
            {{file.originalName}}
          </template>

          <iframe :src="getViewerUrl(file)" frameborder="0" width="100%" :height="tableMaxHeight"></iframe>
        </b-tab>
        <template #tabs-end>
          <li role="presentation" class="nav-item align-self-center">
            <b-button v-b-toggle.sidebar-1 class="ml-2" variant="outline-primary">
              <b-icon icon="gear-fill" aria-hidden="true"></b-icon>
            </b-button>
            <!-- <i class="fa fa-plus mx-3" aria-hidden="true" v-b-toggle.sidebar-1></i> -->
          </li>
        </template>


    </b-tabs>

    </div>

    <!-- 右侧详情条 -->
    <b-sidebar id="sidebar-1" title="报销入账" right shadow>
      <div id="alert" class="px-3 py-2"></div>
      <div class="px-3 py-2">
        <p>报销入账详情:</p>
        <hr>
        <div v-if="invoice.expenseStatus=='1'">
          <div class="row my-2"><div class="col-4">报销单</div><div class="col-8">{{invoice.expenseReportId}}</div></div>
          <div class="row my-2"><div class="col-4">报销人</div><div class="col-8">{{invoice.expenseEmpName}}</div></div>
          <div class="row my-2"><div class="col-4">报销时间</div><div class="col-8">{{invoice.expenseTime}}</div></div>
        </div>
        <div v-if="invoice.accStatus=='1'">
          <div class="row my-2"><div class="col-4">财务</div><div class="col-8">{{invoice.accUserName}}</div></div>
          <div class="row my-2"><div class="col-4">凭证号</div><div class="col-8">{{invoice.voucherId}}</div></div>
          <div class="row my-2"><div class="col-4">入账时间</div><div class="col-8">{{invoice.accTime}}</div></div>
        </div>
        <div v-if="invoice.accStatus=='0'">
          <p>未入账</p>
        </div>
        <!-- 按钮组 -->
        <div class="row mt-4 px-3" v-if="isUserLogined">
          <b-button variant="primary" class="mr-2" @click="handleDownload()">下载</b-button>
          <b-button variant="primary" class="mr-2" @click="openExpenseDialog(invoice.id)" v-if="invoice.expenseStatus=='0' && invoice.accStatus=='0'">报销</b-button>
          <b-button variant="outline-danger" class="mr-2" @click="handleCancelExpense(invoice.id)" v-if="invoice.expenseStatus=='1' && invoice.accStatus=='0'">取消报销</b-button>
          <b-button variant="primary" class="mr-2" @click="openAccountDialog(invoice,'account')"  v-if="invoice.accStatus=='0'">入账</b-button>
          <b-button variant="outline-danger" class="mr-2" @click="openAccountDialog(invoice,'unaccount')" v-if="invoice.accStatus=='1'">取消入账</b-button>
        </div>

      </div>
    </b-sidebar>

    <!-- 入账对话框 -->
    <b-modal
      id="accountModal"
      title="入账"
      incline
      v-model="accountDialogVisible"
      @ok="handleAccount('account')"
    >
      <template slot="modal-ok">入账</template>
      <template slot="modal-cancel">取消</template>

      <form ref="uploadParam">
        <b-form-group label="选择企业">
          <b-form-select
            style="min-width:130px;"
            :options="accEntList"
            v-model="accountParam.entCode"
          ></b-form-select>
        </b-form-group>
        <b-form-group label="凭证编号">
          <b-form-input v-model="accountParam.voucherId" placeholder="请输入凭证编号"></b-form-input>
        </b-form-group>
        <b-form-group label="报销单编号">
          <b-form-input v-model="accountParam.expenseReportId" placeholder="请输入报销单编号"></b-form-input>
        </b-form-group>
        <b-form-group label="报销人">
          <b-form-input v-model="accountParam.expenseEmpName" placeholder="请输入报销人姓名"></b-form-input>
        </b-form-group>
        <b-form-group label="入账日期">
          <b-form-datepicker v-model="localAccTime" :value-as-date="true" locale="zh" class="mb-2"></b-form-datepicker>
        </b-form-group>
      </form>
    </b-modal>

    <!-- 报销对话框 -->
    <b-modal
      id="expenseModal"
      title="报销"
      incline
      v-model="expenseDialogVisible"
      @ok="handleExpense()"
    >
      <template slot="modal-ok">报销</template>
      <template slot="modal-cancel">取消</template>

      <form ref="uploadParam2">
        <b-form-group label="报销单编号">
          <b-form-input v-model="expenseParam.expenseReportId" placeholder="请输入报销单编号"></b-form-input>
        </b-form-group>
        <b-form-group label="报销人">
          <b-form-input v-model="expenseParam.expenseEmpName" placeholder="请输入报销人姓名"></b-form-input>
        </b-form-group>
        <b-form-group label="报销日期">
          <b-form-datepicker v-model="expenseParam.expenseTime" :value-as-date="true" locale="zh" class="mb-2"></b-form-datepicker>
        </b-form-group>
      </form>
    </b-modal>

  </div>
</template>

<script>
import * as invoiceFacade from "../../../api/invoice-facade.js";
import * as accountFacade from "../../../api/account-facade.js";
import * as entFacade from "../../../api/ent-facade.js";
import { mapState } from "vuex";
import {
  addHours,
} from "date-fns/esm";

export default {
  props:{
    file: String,
    file1: File
  },
  // validations:
  data() {
    return {
        id:"",
        tableMaxHeight: 500,
        tabs: [],
        tabCounter: 0,
        files:{},
        invoice:{},
        addAttachmentDialogVisible: false,
        addAttachmentDto: {},
        showAlert: false,
        msg: "",
        isUserLogined: false,
        removeAttachmentDialogVisible: false,
        currentAttachmentId:"",
        currentAttachmentFileName: "",
        // 对话框控制
        accountDialogVisible: false,
        expenseDialogVisible: false,

        //入账对象
        accountParam: {
          invoiceId: "",
          entCode: "",
          accTime: null
        },
        // 报销对象
        expenseParam: {
          invoiceId: "",
          entCode: "",
          expenseTime: new Date()
        },

        accEntList: [],
        localAccTime: new Date(),

};
  },
  created() {
    // this.id = this.$route.query.id;
    this.init()
    this.$bvToast.show('example-toast')
  },
  mounted() {
    window.onresize = () => {
      this.changeIFrameMaxHeight()
    }
    this.changeIFrameMaxHeight()
  },
  computed: {
    ...mapState("admin/user", ["info"])
  },
  methods: {
    validateState({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null;
    },
    init(){
      var id = this.$route.query.id
      invoiceFacade
        .getFiles(id) // 异步调用后台接口
        .then(res => {
          this.files = res.invoiceCheckViewDtos; // 
          this.isUserLogined = res.logined;
          this.invoice = res.invoiceDto;
          // 登录用户，则获取记账企业信息
          if(this.isUserLogined){
            this.getEntInfo();
          }
        })
        .catch(err => {
          console.log("err", err);
        });

    },
    // 自动更改iframe高度
    changeIFrameMaxHeight () {
      let height = document.body.offsetHeight // 网页可视区域高度
      this.tableMaxHeight = height - 60
      // console.log(this.tableMaxHeight)
    },

    // 获取iframe的显示地址
    getViewerUrl(file){
      var downloadUrl = process.env.VUE_APP_PREFIX + file.downloadUrl
      let viewerUrl;
      if(file.fileFormat == "OFD"){
        viewerUrl = "./ofd/index.html?file=";
      }else if(file.fileFormat == "PDF"){
        viewerUrl = "./pdf/web/viewer.html?file=";
      }else{
        viewerUrl = "./#/imageViewer?file=";
      }

      return viewerUrl + encodeURIComponent(downloadUrl)
    },

    //获取企业信息
    async getEntInfo() {
      this.pageLoading = true;
      entFacade
        .findByUser()
        .then(res => {
          this.parseEntInfo(res);
        })
        .catch(err => {
          console.log("err", err);
          this.pageLoading = false;
        });
    },

    //解析企业信息
    parseEntInfo(res) {
      this.pageLoading = false;
      let entList = [{ text: "受票方", value: "" }];
      let accEntList = [];
      if (res) {
        res.map(item => {
          let ent = {};
          ent.text = item.entName;
          ent.value = item.entCode;
          entList.push(ent);
          accEntList.push(ent);
        });
      }

      this.entList = entList;
      this.accEntList = accEntList;
      if (this.accEntList.length > 0) {
        this.accountParam.entCode = this.accEntList[0].value;
      }
    },

    // 打开报销窗口
    openExpenseDialog(id){
      this.expenseDialogVisible = true;
      this.expenseParam.invoiceId = id;
      // this.expenseParam.expenseReportId = "";
      // this.expenseParam.expenseEmpName = "";
      this.expenseParam.expenseTime = new Date();
    },

    // 执行报销
    handleExpense(){
      this.pageLoading = true;
      console.log(this.expenseParam)
      accountFacade
        .expenseByInvoiceId(this.expenseParam)
        .then(() => {
          this.pageLoading = false;

          this.$message({
            message: "记录员工报销成功",
            type: "success"
          });
          this.invoice.expenseReportId = this.expenseParam.expenseReportId;
          this.invoice.expenseEmpName = this.expenseParam.expenseEmpName;
          this.invoice.expenseTime = this.expenseParam.expenseTime;
          this.invoice.expenseStatus = "1"
        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
      this.expenseParam.invoiceId = "";
      // this.expenseParam.expenseReportId = "";
      // this.expenseParam.expenseEmpName = "";
      this.expenseParam.expenseTime = new Date();

    },

    // 取消报销
    handleCancelExpense(id){
      this.$bvModal
        .msgBoxConfirm("确认要撤销该发票的报销信息吗？", {
          title: "取消报销",
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: "确定",
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            console.log("取消报销")
            accountFacade
              .cancelExpenseByInvoiceId(id)
              .then(() => {
                this.pageLoading = false;

                this.$message({
                  message: "取消报销成功",
                  type: "success"
                });
                this.invoice.expenseReportId = null;
                this.invoice.expenseEmpName = null;
                this.invoice.expenseTime = null;
                this.invoice.expenseStatus = "0"

              })
              .catch(err => {
                this.pageLoading = false;
                console.log("err", err);
              });
              }
        })
        .catch(err => {
          console.log(err);
        });

    },

    openAccountDialog(item, type) {
      let buyerTaxCode = item.buyerTaxCode;
      this.accountParam.invoiceId = item.id;
      if (type == "account") {
        this.accountParam.entCode = buyerTaxCode;
        // this.accountParam.voucherId = item.voucherId;
        if(item.expenseReportId != null){
          this.accountParam.expenseReportId = item.expenseReportId;
        }
        if(item.expenseEmpName != null){
          this.accountParam.expenseEmpName = item.expenseEmpName;
        }
        this.accountDialogVisible = true;
        return;
      }
      let typeStr = type == "account" ? "入账" : "取消入账";
      this.$bvModal
        .msgBoxConfirm("确认" + typeStr + "吗？", {
          title: typeStr,
          size: "sm",
          buttonSize: "md",
          okVariant: "primary",
          okTitle: typeStr,
          cancelTitle: "取消",
          footerClass: "p-2",
          hideHeaderClose: false
        })
        .then(value => {
          if (value) {
            type == "account"
              ? this.handleAccount()
              : this.handleCancelAccount();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //记账or取消记账动作执行
    handleAccount() {
      //记账
      this.pageLoading = true;
      this.localAccTime = addHours(this.localAccTime, 8);
      this.accountParam.accTime = this.localAccTime;
      accountFacade
        .accountByInvoiceId(this.accountParam)
        .then(() => {
          this.pageLoading = false;

          this.$message({
            message: "入账成功",
            type: "success"
          });
          // 同步更新记账状态
          this.init()
        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
      this.accountParam.entCode = "";
      this.accountParam.invoiceId = "";
      this.localAccTime = new Date();
    },
    handleCancelAccount() {
      //记账

      this.pageLoading = true;
      accountFacade
        .cancelAccountByInvoiceId(this.accountParam.invoiceId)
        .then(() => {
          this.pageLoading = false;
          this.$message({
            message: "取消入账成功",
            type: "success"
          });
          //
          this.init()
        })
        .catch(err => {
          this.pageLoading = false;
          console.log("err", err);
        });
    },

    //下载
    handleDownload() {
      let id = this.$route.query.id;
      let downloadUrl = process.env.VUE_APP_INVOICE_DOWNLOAD_PREFIX + id;
      window.open(downloadUrl, "_blank");

    },

  }
};
</script>

<style scoped>
  .nav-link {
    color: #000000 !important;
  }
  .nav-link:hover{
    background-color: #ffffff;
  }
</style>
